import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserData, getUserId } from "../../../Base/helper/baseFunctions";

export const GetWageReportHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/getWageReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            employee_id: params?.employee_id || null,
            month: params?.month,
            year: String(params?.year),
            location: params?.location || null,
            user_id: getUserId()
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}

export const GenerateWageReportHelper = async (params) => {
    return await axiosInstance(`finance/ancillary/generateWageReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params?.employee_id || null,
            month: params?.month,
            year: params?.year,
            user_id: getUserId(),
            custom_payable_days: params?.custom_payable_days || 0

        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}

export const GenerateEPFOReportHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/generateEPFOReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            emp_user_id: getUserId(),
            month: params?.month,
            year: params?.year,
            tab: params?.tab,
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}
export const InEligibleReportHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/ineligibleReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            from_date: params.from_date,
            to_date: params.to_date,
            emp_id: params.emp_id,
            reporting_manager_emp_id: data?.employee_id
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}
export const OnHoldReportHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/onholdReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null            
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}

export const PayPeriodDateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/payPeriodDate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            month: params?.month,
            year: params?.year,
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}

export const GetWageReportNotProcessedHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/getWageReportNotProcessed`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            month: params?.month,
            year: String(params?.year),
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null,

        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}
export const GetDailyWageReportHelper = async (params) => {
    return await axiosInstance(`finance/ancillary/getDailyWageReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params?.employee_id ||  null,
            month: params?.month,
            year: String(params?.year),
            location: params?.location || null,
            user_id: getUserId()
        },
    })
        .then((res) => {
            return { message: "Successfully retrieved", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return {
                message: "Unable to retrieve data",
                hasError: true,
                data: err?.response?.data,
            };
        });
};

export const GetDailyWageReportNotProcessedHelper = async (params) => {
    return await axiosInstance(`finance/ancillary/getDailyWageReportNotProcessed`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            month: params?.month,
            year: String(params?.year),
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null,
        },
    })
        .then((res) => {
            return { message: "Successfully retrieved", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return {
                message: "Unable to retrieve data",
                hasError: true,
                data: err?.response?.data,
            };
        });
};

export const GenerateDailyWageReportHelper = async (params) => {
    return await axiosInstance(`finance/ancillary/generateDailyWageReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params?.employee_id || null,
            month: params?.month,
            year: params?.year,
            user_id: getUserId()
        },
    })
        .then((res) => {
            return { message: "Successfully generated", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return {
                message: "Unable to generate report",
                hasError: true,
                data: err?.response?.data,
            };
        });
};

// Contractual

export const GetContractualWageReportHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/getContractualWageReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            employee_id: params?.employee_id || null,
            month: params?.month,
            year: String(params?.year),
            location: params?.location || null,
            user_id: getUserId()
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}

export const GetContractualWageReportNotProcessedHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`finance/ancillary/getContractualWageReportNotProcessed`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            month: params?.month,
            year: String(params?.year),
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null,

        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}

export const GenerateContractualWageReportHelper = async (params) => {
    return await axiosInstance(`finance/ancillary/generateContractualWageReport`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params?.employee_id || null,
            month: params?.month,
            year: params?.year,
            user_id: getUserId(),
            custom_payable_days: params?.custom_payable_days || 0

        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived ", hasError: false, data: err?.response?.data }
        })
}
